import { useState } from "react";
import { Modal } from "antd";
import Swal from "sweetalert2";
import { hideLoader, showLoader } from "../../../../../utils/loader";
//To be used:::import { emailValidator } from "../../../../../utils/helper";
import validator from "validator";
import { customBaseUrl, httpPost } from "../../../../../store/http";
import { Typography, Stack, Box, TextField, Button } from "@mui/material";

const UpdateAdmninPass = ({ showModal, hideModal, email }) => {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    showLoader();

    if (validator.isEmpty(currentPassword)) {
      hideLoader();
      Swal.fire("Oops!", "Current password cannot be empty", "error");
      return;
    }
    if (validator.isEmpty(newPassword)) {
      hideLoader();
      Swal.fire("Oops!", "New password cannot be empty", "error");
      return;
    }
    if (validator.isEmpty(confirmPassword)) {
      hideLoader();
      Swal.fire("Oops!", "Confirm new password cannot be empty", "error");
      return;
    }
    if (newPassword !== confirmPassword) {
      hideLoader();
      Swal.fire(
        "Oops!",
        "New password and confirm password do not match",
        "error",
      );
      return;
    }

    const postData = {
      currentPassword: currentPassword,
      newPassword: newPassword,
      confirmPassword: confirmPassword,
    };
    const res = await httpPost(
      `${customBaseUrl.authUrl}/auth/change-password`, // New endpoint
      postData,
      true,
    );
    if (res.success) {
      hideLoader();
      Swal.fire("Done", res.message, "success").then(() => {
        hideModal(false);
      });
    } else {
      hideLoader();
      console.error("Backend error response:", res); // Log the full response
      Swal.fire("Oops!", res.message || "Failed to change password", "error");
    }
  };
  return (
    <Modal
      visible={showModal}
      closable={false}
      footer={null}
      centered
      onCancel={() => {
        hideModal(false);
      }}
    >
      <Box sx={{ minHeight: "50vh" }}>
        <Typography
          variant="h3"
          gutterBottom
          style={{ textAlign: "center", marginBottom: "30px" }}
        >
          Change your password
        </Typography>
        <Stack spacing={3} mb={3}>
          <Box>
            <Typography variant="subtitle1" fontWeight="medium">
              Current Password
            </Typography>
            <TextField
              fullWidth
              id="current-password"
              type="password"
              placeholder="Current Password"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              size="small"
            />
          </Box>

          <Box>
            <Typography variant="subtitle1" fontWeight="medium">
              New Password
            </Typography>
            <TextField
              fullWidth
              id="new-password"
              type="password"
              placeholder="New Password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              size="small"
            />
          </Box>
          <Box>
            <Typography variant="subtitle1" fontWeight="medium">
              Confirm New Password
            </Typography>
            <TextField
              fullWidth
              id="confirm-new-password"
              type="password"
              placeholder="Confirm New Password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              size="small"
            />
          </Box>

          <Button
            htmlType="submit"
            variant="contained"
            style={{ marginTop: "45px" }}
            onClick={handleSubmit}
          >
            Save Password
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
};

export default UpdateAdmninPass;
